export class AppUtilityTypes {
    static UPDATE_POPUP: string = 'update_popup';
}

export class UserDataReducerState {
    userData!: any;
}